import {
    GET_OPERATOR_TOUR_DETAILS_START,
    GET_OPERATOR_TOUR_DETAILS_SUCCESS,
    GET_OPERATOR_TOUR_DETAILS_ERROR
} from "../Constants/OperatorTourDetailsConstant";

const initialState = {
    loading: false,
    operatorTourDetailsData:{},
  };

  export default function OperatorTourDetailsReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case GET_OPERATOR_TOUR_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case GET_OPERATOR_TOUR_DETAILS_SUCCESS:
            return {
                ...state,
                operatorTourDetailsData: action.payload,
                loading: false,
            };
        case GET_OPERATOR_TOUR_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}